const namespace = 'tutorial';

export const SET_IS_EXPANDED = `${namespace}/SET_IS_EXPANDED`;
export const SKIP_STEP = `${namespace}/SKIP_STEP`;
export const FINISH_TUTORIAL = `${namespace}/FINISH_TUTORIAL`;
